// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qC3E","disabled":"styles_disabled__S6eSy"};